export const ACCESS_TOKEN_KEY = 'X-ID-TOKEN';
export const REFRESH_TOKEN_KEY = 'X-REFRESH-TOKEN';

export const USER_SUB_KEY = 'X-SUB-ID';
